// Copyright (c) 2017 Deere & Company

import OpenServiceIntervals, {getDefaultState as getOpenServiceIntervalsDefaultState} from '../state/open-service-intervals';
import actions from '../../../action-list';
import {getDefaultState} from '../state';

const resetOpenServiceIntervals = () => getOpenServiceIntervalsDefaultState();

const updateOpenServiceIntervals = (state, action) =>
    OpenServiceIntervals.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().openServiceIntervals, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MAINTENANCE_PLAN]: resetOpenServiceIntervals,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_OPEN_SERVICE_INTERVALS]: updateOpenServiceIntervals
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/open-service-intervals.js